export const demoCredits = {
  includedTotal: 1000,
  includedUsed: 660,
  includedAvailable: 340,
  additionalAvailable: 0,
};

export const formatCredits = (value) => new Intl.NumberFormat("pt-BR").format(value);

export const exampleMetrics = [
  { label: "Vendas no período", value: "R$ 8,4 mi", change: "+12,8%" },
  { label: "Unidades vendidas", value: "32", change: "+4 unidades" },
  { label: "Recebimentos", value: "R$ 6,9 mi", change: "+8,2%" },
];

export const exampleChart = [
  { month: "Abr", vendas: 5.2, recebimentos: 4.4 },
  { month: "Mai", vendas: 6.1, recebimentos: 5.0 },
  { month: "Jun", vendas: 5.8, recebimentos: 5.4 },
  { month: "Jul", vendas: 7.0, recebimentos: 5.7 },
  { month: "Ago", vendas: 7.5, recebimentos: 6.1 },
  { month: "Set", vendas: 8.4, recebimentos: 6.9 },
];

export const exampleRows = [
  { name: "Varandas do Atlântico", sales: "R$ 3,2 mi", received: "R$ 2,7 mi", status: "Dentro da meta" },
  { name: "Parque das Águas", sales: "R$ 2,8 mi", received: "R$ 2,3 mi", status: "Acompanhar" },
  { name: "Reserva Central", sales: "R$ 2,4 mi", received: "R$ 1,9 mi", status: "Dentro da meta" },
];

export const demoAnswer = {
  id: "answer-example",
  role: "assistant",
  text: "Ainda não há consulta aos sistemas nesta conversa. Os indicadores abaixo são ilustrativos; quando as integrações estiverem conectadas, a análise poderá mostrar fontes, filtros, regras e horários de atualização.",
  visualization: true,
  sources: ["CV CRM", "Sienge"],
};

export const initialDemoState = {
  projects: [
    { id: "projeto-comercial", name: "Reunião comercial", description: "Perguntas e análises para acompanhar o desempenho de vendas.", updatedAt: "Hoje" },
    { id: "projeto-varandas", name: "Acompanhamento Varandas", description: "Visão do empreendimento entre CRM e ERP.", updatedAt: "Ontem" },
    { id: "projeto-recebimentos", name: "Recebimentos e pendências", description: "Acompanhamento financeiro ilustrativo.", updatedAt: "Esta semana" },
  ],
  chats: [
    {
      id: "chat-desempenho",
      projectId: "projeto-comercial",
      title: "Desempenho por empreendimento",
      updatedAt: "Hoje",
      messages: [
        { id: "question-example", role: "user", text: "Como estão as vendas e os recebimentos por empreendimento?" },
        demoAnswer,
      ],
    },
    {
      id: "chat-varandas",
      projectId: "projeto-varandas",
      title: "Panorama do Varandas",
      updatedAt: "Ontem",
      messages: [
        { id: "question-varandas", role: "user", text: "Mostre um panorama do Varandas do Atlântico." },
        { ...demoAnswer, id: "answer-varandas" },
      ],
    },
  ],
};

export const exampleArtifacts = [
  { id: "painel-comercial", projectId: "projeto-comercial", title: "Painel comercial", description: "Vendas e recebimentos por empreendimento", kind: "Painel", updatedAt: "Dados ilustrativos", sources: ["CV CRM", "Sienge"] },
  { id: "resumo-varandas", projectId: "projeto-varandas", title: "Resumo do Varandas", description: "Indicadores do empreendimento", kind: "Relatório", updatedAt: "Dados ilustrativos", sources: ["CV CRM"] },
];
